var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weblinkfield",style:({
       height: _vm.height ? _vm.height+'px' : undefined,
       textAlign: _vm.fieldRec.value_align || 'left',
       fontSize: _vm.fieldRec.font_size ? _vm.fieldRec.font_size+'px': null,
   }),on:{"click":function($event){return _vm.openWindow()}}},[_vm._v(" "+_vm._s(_vm.fieldRec.display_value ? _vm.fieldRec.display_value : _vm.fieldRec.property)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }